import { css } from 'styled-components';

export const media = {
  // example from styled-components
  handheld: (...args) => css`
    @media (max-width: 420px) {
      ${css(...args)};
    }
  `,
  mobile: (...args) => css`
    @media (max-width: 768px) {
      ${css(...args)};
    }
  `,
  tablet: (...args) => css`
    @media (min-width: 769px) {
      ${css(...args)};
    }
  `,
  tabletOnly: (...args) => css`
    @media (min-width: 769px, max-width: 1023px) {
      ${css(...args)};
    }
  `,
  touch: (...args) => css`
    @media (max-width: 1023px) {
      ${css(...args)};
    }
  `,
  desktop: (...args) => css`
    @media (min-width: 1024px) {
      ${css(...args)};
    }
  `,
  desktopOnly: (...args) => css`
    @media (min-width: 769px, max-width: 1215px) {
      ${css(...args)};
    }
  `,
  widescreen: (...args) => css`
    @media (min-width: 1216px) {
      ${css(...args)};
    }
  `,
  widescreenOnly: (...args) => css`
    @media (min-width: 1216px, max-width: 1407px) {
      ${css(...args)};
    }
  `,
  fullhd: (...args) => css`
    @media (min-width: 1408px) {
      ${css(...args)};
    }
  `
};



// WEBPACK FOOTER //
// ./src/utils/style-utils.js